import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization, UserJWT } = {}) =>
  jwt || Authorization || UserJWT || "";
const isUuid = (value) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    String(value || "").trim(),
  );
const toIsoTimestamp = (date) => {
  if (!date) return "";
  return new Date(date).toISOString().slice(0, 19);
};
const toJavaTimestamp = (date) => {
  if (!date) return "";
  const d = new Date(date);

  const pad = (n) => n.toString().padStart(2, "0");

  return (
    d.getFullYear() +
    "-" +
    pad(d.getMonth() + 1) +
    "-" +
    pad(d.getDate()) +
    " " +
    pad(d.getHours()) +
    ":" +
    pad(d.getMinutes()) +
    ":" +
    pad(d.getSeconds())
  );
};
const companyController = {
  getCompanyEmployees: ({ companyId, page, size, jwt, search }) => {
    return Utils.controller(
      "api/company/v1/companyEmployees",
      "",
      "GET",
      `companyId=${companyId}&page=${page}&search=${search || ""}&size=${size}`,
      true,
      getAuth({ jwt }),
      true,
    );
  },

  userPrimaryCompanies: ({ Authorization, userId }) => {
    if (!isUuid(userId)) return Promise.resolve({ status: 400, data: [] });

    return Utils.controller(
      "api/company/v1/userPrimaryCompanies",
      "",
      "GET",
      `userId=${encodeURIComponent(userId)}`,
      true,
      Authorization,
      true,
    );
  },

  addCompanyEmployees: ({ addCompanyEmloyeeRequest, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/addCompanyEmployee",
      addCompanyEmloyeeRequest,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getBusinesProfileCompanies: ({ businessProfileID, Authorization }) => {
    return Utils.controller(
      "api/businessProfile/v1/getBusinessProfileCompanies",
      "",
      "POST",
      `businessProfileID=${businessProfileID}`,
      true,
      Authorization,
      true,
    );
  },

  CompanyRegistration: ({
    companyRegisterRequest,
    CompanyRegistraterDTO,
    Authorization,
    UserJWT,
  }) => {
    return Utils.controller(
      "api/company/v1/companyRegistration",
      companyRegisterRequest || CompanyRegistraterDTO,
      "POST",
      "",
      true,
      getAuth({ Authorization, UserJWT }),
      true,
    );
  },

  addCompanyAddress: ({ addCompanyAddressRequest, Authorization, jwt }) => {
    return Utils.controller(
      "api/company/v1/addCompanyAddress",
      addCompanyAddressRequest,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  updateAddCompanyAttachments: ({ addAttachments, Authorization }) => {
    return Utils.controller(
      "api/company/v1/updateCompanyAttachments",
      addAttachments,
      "PUT",
      "",
      true,
      Authorization,
      true,
    );
  },

  updateCompanyDescription: ({ companyDescription, Authorization, jwt }) => {
    return Utils.controller(
      "api/company/v1/updateCompanyDescription",
      companyDescription,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  updatecompanydetails: ({ updateDetails, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/updateCompnayDetails",
      updateDetails,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  deleteCompanyEmployee: ({ removeEmployeeRequestDTO, Authorization }) => {
    return Utils.controller(
      "api/company/v1/deleteCompanyEmployee",
      removeEmployeeRequestDTO,
      "DELETE",
      "",
      true,
      Authorization,
      true,
    );
  },

  toggleEnfroceMFA: ({ companyID, jwt }) => {
    return Utils.controller(
      "api/company/v1/toggleEnfrocemfa",
      "",
      "POST",
      `companyID=${companyID}`,
      true,
      getAuth({ jwt }),
      true,
    );
  },

  updateCompanyAttachmentStatus: ({ attachments, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/updateCompanyAttachmentStatus",
      attachments,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getCompanyDetails: ({ Authorization, copmayRequest }) => {
    return Utils.controller(
      "api/company/v1/getCompanyDetails",
      copmayRequest,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  getCompanyRequests: ({ page, size, status, userType, search, jwt }) => {
    return Utils.controller(
      "api/company/v1/companyRequests",
      "",
      "GET",
      `page=${page}&search=${search || ""}&size=${size}&status=${status || ""}&userType=${userType || ""}`,
      true,
      getAuth({ jwt }),
      true,
    );
  },

  sendapprovedemail: ({ statusPayload, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/approvedEmail",
      statusPayload,
      "POST",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  sendResubmissionEmail: ({ Authorization, companyEmail }) => {
    return Utils.controller(
      "api/company/v1/resubmissionEmail",
      companyEmail,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  sendrejectedemail: ({ companyEmail, Authorization }) => {
    return Utils.controller(
      "api/company/v1/rejectedEmail",
      companyEmail,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  toggleVerifyTaxNumber: ({ request, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/toggleVerifyTaxNumber",
      request,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  updateTaxNumber: ({ updateTaxNb, jwt, Authorization }) => {
    return Utils.controller(
      "api/company/v1/updateTaxNumber",
      updateTaxNb,
      "PUT",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
  addProduct: ({ productRequestDto, Authorization }) => {
    return Utils.controller(
      "api/product/v1/addProduct",
      productRequestDto,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },

  QrCodeRequests: ({
    companyId,
    companyName,
    fromDate,
    page,
    qrCodeStatus,
    search,
    size,
    toDate,
    Authorization,
  }) => {
    const params = new URLSearchParams();

    if (companyId) params.append("companyId", companyId);
    if (companyName) params.append("companyName", companyName);
    if (fromDate) params.append("fromDate", fromDate);
    if (page !== undefined) params.append("page", page);
    if (qrCodeStatus) params.append("qrCodeStatus", qrCodeStatus);
    if (search) params.append("search", search);
    if (size !== undefined) params.append("size", size);
    if (toDate) params.append("toDate", toDate);
    const queryString = params.toString();
    return Utils.controller(
      "api/qrcodes/v1/qrCodeRequests",
      "",
      "GET",
      queryString,
      true,
      Authorization,
      true,
    );
  },
  getQuickActions: ({ Authorization, companyId }) => {
    return Utils.controller(
      "api/product/v1/getQuickActions",
      "",
      "PUT",
      `companyId=${companyId}`,
      true,
      Authorization,
      true,
    );
  },
  QrBulkJobs: ({ req, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs",
      req,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  QrBulkpause: ({ jobId, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs/pause",
      "",
      "POST",
      `jobId=${jobId}`,
      true,
      Authorization,
      true,
    );
  },
  QrBulkResume: ({ jobId, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs/resume",
      "",
      "POST",
      `jobId=${jobId}`,
      true,
      Authorization,
      true,
    );
  },
  QrBulkCancel: ({ jobId, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs/cancel",
      "",
      "POST",
      `jobId=${jobId}`,
      true,
      Authorization,
      true,
    );
  },
  QrBulkRetyFailed: ({ jobId, Authorization }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs/retry-failed",
      "",
      "POST",
      `jobId=${jobId}`,
      true,
      Authorization,
      true,
    );
  },
  QrBulkJobsStatus: ({ jobId, Authorization, skipGlobalLoader = false }) => {
    return Utils.controller(
      "api/v1/qr/bulk/v1/qr-bulk-jobs",
      "",
      "GET",
      `jobId=${jobId}`,
      true,
      Authorization,
      true,
      skipGlobalLoader,
    );
  },
  Enableordisableacompanyemployee: ({ request, Authorization }) => {
    return Utils.controller(
      "api/company/v1/setCompanyEmployeeEnabled",
      request,
      "PUT",
      "",
      true,
      Authorization,
      true,
    );
  },
};

export default companyController;
